import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VariationRoutingModule } from './variation-routing.module';
import { VariationComponent } from './variation.component';


@NgModule({
  declarations: [VariationComponent],
  imports: [
    CommonModule,
    VariationRoutingModule
  ],
  exports: [VariationComponent]
})
export class VariationModule { }
